import copyToClipboard from "../modules/copyToClipboard";
import subscribe from "../modules/subscribe";

copyToClipboard(".share__icon--copy");
subscribe();
